
import CompanySite from 'models/CompanySite';

import Component from './component';

export interface Props {
    company: CompanySite;
    isEditable:boolean;
}

Component.defaultProps = {};
export default Component;